import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { useIntl } from 'react-intl';

import css from './BooksTimeItem.module.scss';

interface Props {
  className?: string;
  date?: string;
  startTime: string;
  endTime: string;
  instructors?: string[];
  withPadding?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const BooksTimeItem = ({
  className,
  date,
  startTime,
  endTime,
  instructors,
  withPadding,
  onClick,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(
    css.BooksTimeItem,
    { [css.withPadding]: withPadding },
    className,
  );

  return (
    <div className={classes} onClick={onClick}>
      {date && (
        <span className={css.BooksTimeItem__Date}>
          {intl.formatDate(df.format(date), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
          })}
        </span>
      )}
      <span className={css.BooksTimeItem__Time}>
        {startTime}
        <span> - </span>
        {endTime}
      </span>
      {instructors && instructors.length > 0 && (
        <span className={css.BooksTimeItem__Instructor}>
          {intl.formatMessage({ id: 'books.forms.staff' })}:
          {instructors.map((instructor, i) => (
            <span className={css.BooksTimeItem__InstructorName} key={i}>
              {instructor}
            </span>
          ))}
        </span>
      )}
    </div>
  );
};

export default BooksTimeItem;
